import { render, staticRenderFns } from "./StageTabs.vue?vue&type=template&id=30169c1a&scoped=true&"
import script from "./StageTabs.vue?vue&type=script&lang=js&"
export * from "./StageTabs.vue?vue&type=script&lang=js&"
import style0 from "./StageTabs.vue?vue&type=style&index=0&id=30169c1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30169c1a",
  null
  
)

export default component.exports